import { graphql } from '~/types/gql/generated/gql'

export const GetCurrentProfileGqlQuery = graphql(`
  query GetCurrentProfile($id: Float!) {
    profile(id: $id) {
        id
        givenName
        familyName
        email
        isAdmin
        allOrganisations {
          id
        }
        currentOrganisation {
          ...OrganisationBaseInfo
          kyc {
            id
            startedAt
            status
          }
        }
    }
  }
`)
